(function () {


// =========================================================
// PREVENT DOUBLE INITIALISATION
// =========================================================

if (window.__MOTS_INVITATION_INITIALIZED__) {

    console.log(
        "[Invitation] Already initialized — skipping duplicate script."
    );

    return;

}

window.__MOTS_INVITATION_INITIALIZED__ = true;


// =========================================================
// CONFIG
// =========================================================

const API_URL =
    "https://invitation-registry.makingoftheseason.workers.dev";


// =========================================================
// STATE
// =========================================================

let invitationStateReady = false;

let currentInvitationStates = [];

let observer = null;

let countdownTimer = null;

let checkoutClickListenerAttached = false;

let invitationClickListenerAttached = false;


// =========================================================
// STORAGE KEYS
// =========================================================

const STATE_KEY =
    "mots_invitation_state";

const EXPIRES_KEY =
    "mots_invitation_expires";

const DATA_KEY =
    "mots_invitation_data";


// =========================================================
// PROCESS INVITATION ELEMENTS
// =========================================================

function processInvitationElements() {

    if (!invitationStateReady) {

        return;

    }


    const elements =
        document.querySelectorAll(
            "[data-invitation]"
        );


    if (!elements.length) {

        return;

    }


    elements.forEach(element => {

        const requiredState =
            element.getAttribute(
                "data-invitation"
            );


        if (
            currentInvitationStates.includes(
                requiredState
            )
        ) {

            element.removeAttribute(
                "data-invitation"
            );

            return;

        }


        element.remove();

    });


    console.log(
        "[Invitation] Applied states:",
        currentInvitationStates
    );


    if (
        currentInvitationStates.includes(
            "active"
        )
    ) {

        startCountdown();

    }


    initialiseCheckoutButtons();

}


// =========================================================
// APPLY INVITATION STATE
// =========================================================

function applyInvitationState(states) {

    currentInvitationStates =
        states;

    invitationStateReady =
        true;


    processInvitationElements();

}


// =========================================================
// DOM OBSERVER
// =========================================================

function startInvitationObserver() {

    if (observer) {

        return;

    }


    observer =
        new MutationObserver(
            function (mutations) {

                let somethingAdded =
                    false;


                for (
                    const mutation of mutations
                ) {

                    if (
                        mutation.addedNodes &&
                        mutation.addedNodes.length
                    ) {

                        somethingAdded =
                            true;

                        break;

                    }

                }


                if (!somethingAdded) {

                    return;

                }


                processInvitationElements();

                initialiseInvitationButtons();

                initialiseCheckoutButtons();

            }
        );


    observer.observe(
        document.documentElement,
        {
            childList: true,
            subtree: true
        }
    );


    console.log(
        "[Invitation] DOM observer started"
    );

}


// =========================================================
// SAVE LOCAL INVITATION STATE
// =========================================================

function saveInvitationState(
    state,
    expiresAt
) {

    localStorage.setItem(
        STATE_KEY,
        state
    );


    if (expiresAt) {

        localStorage.setItem(
            EXPIRES_KEY,
            expiresAt
        );

    } else {

        localStorage.removeItem(
            EXPIRES_KEY
        );

    }

}


// =========================================================
// GET LOCAL INVITATION STATE
// =========================================================

function getLocalInvitationState() {

    const state =
        localStorage.getItem(
            STATE_KEY
        );


    const expiresAt =
        localStorage.getItem(
            EXPIRES_KEY
        );


    if (!state) {

        return "inactive";

    }


    if (
        state === "active" &&
        expiresAt
    ) {

        const expirationTime =
            new Date(
                expiresAt
            ).getTime();


        if (
            Number.isNaN(
                expirationTime
            )
        ) {

            saveInvitationState(
                "inactive"
            );

            return "inactive";

        }


        if (
            Date.now() >=
            expirationTime
        ) {

            saveInvitationState(
                "expired"
            );


            return "expired";

        }


        return "active";

    }


    return state;

}


// =========================================================
// GET STORED INVITATION
// =========================================================

function getStoredInvitation() {

    const stored =
        localStorage.getItem(
            DATA_KEY
        );


    if (!stored) {

        return null;

    }


    try {

        return JSON.parse(
            stored
        );

    } catch (error) {

        console.error(
            "[Invitation] Could not parse stored invitation:",
            error
        );

        return null;

    }

}


// =========================================================
// OPEN POPUP
// =========================================================

function openInvitationPopup() {

    const popup =
        document.querySelector(
            ".invitation-module-backdrop"
        );


    if (!popup) {

        console.log(
            "[Invitation] Popup not found."
        );

        return;

    }


    popup.classList.add(
        "is-open"
    );


    popup.removeAttribute(
        "hidden"
    );


    popup.setAttribute(
        "aria-hidden",
        "false"
    );


    document.documentElement.classList.add(
        "invitation-open"
    );


    document.body.classList.add(
        "invitation-open"
    );


    console.log(
        "[Invitation] Popup opened."
    );

}


// =========================================================
// CLOSE POPUP
// =========================================================

function closeInvitationPopup() {

    const popup =
        document.querySelector(
            ".invitation-module-backdrop"
        );


    if (!popup) {

        return;

    }


    popup.classList.remove(
        "is-open"
    );


    popup.setAttribute(
        "aria-hidden",
        "true"
    );


    document.documentElement.classList.remove(
        "invitation-open"
    );


    document.body.classList.remove(
        "invitation-open"
    );


    console.log(
        "[Invitation] Popup closed."
    );

}


// =========================================================
// INVITATION UI BUTTONS
// =========================================================

function initialiseInvitationButtons() {

    if (
        invitationClickListenerAttached
    ) {

        return;

    }


    invitationClickListenerAttached =
        true;


    document.addEventListener(
        "click",
        function (event) {

            // =================================================
            // OPEN BUTTON
            // =================================================

            const openButton =
                event.target.closest(
                    "[data-open-invitation]"
                );


            if (openButton) {

                event.preventDefault();

                openInvitationPopup();

                return;

            }


            // =================================================
            // CLOSE BUTTON
            // =================================================

            const closeButton =
                event.target.closest(
                    ".invitation-module-close"
                );


            if (closeButton) {

                event.preventDefault();

                closeInvitationPopup();

                return;

            }


            // =================================================
            // CLICK BACKDROP
            // =================================================

            const backdrop =
                event.target.closest(
                    ".invitation-module-backdrop"
                );


            if (
                backdrop &&
                event.target === backdrop
            ) {

                closeInvitationPopup();

            }

        },
        true
    );


    console.log(
        "[Invitation] Popup listeners attached."
    );

}


// =========================================================
// COUNTDOWN
// =========================================================

function startCountdown() {

    if (countdownTimer) {

        clearInterval(
            countdownTimer
        );

        countdownTimer = null;

    }


    const expiresAt =
        localStorage.getItem(
            EXPIRES_KEY
        );


    if (!expiresAt) {

        console.log(
            "[Countdown] No expiry found."
        );

        return;

    }


    const expirationTime =
        new Date(
            expiresAt
        ).getTime();


    if (
        Number.isNaN(
            expirationTime
        )
    ) {

        console.error(
            "[Countdown] Invalid expiration date."
        );

        return;

    }


    function updateCountdown() {

        const countdowns =
            document.querySelectorAll(
                ".invitation-countdown"
            );


        const remaining =
            expirationTime -
            Date.now();


        if (
            remaining <= 0
        ) {

            countdowns.forEach(
                countdown => {

                    countdown.textContent =
                        "Invitation Expired";

                }
            );


            clearInterval(
                countdownTimer
            );

            countdownTimer =
                null;


            saveInvitationState(
                "expired"
            );


            applyInvitationState([
                "inactive",
                "expired"
            ]);


            console.log(
                "[Countdown] Expired."
            );


            return;

        }


        const totalSeconds =
            Math.floor(
                remaining / 1000
            );


        const hours =
            Math.floor(
                totalSeconds / 3600
            );


        const minutes =
            Math.floor(
                (totalSeconds % 3600) / 60
            );


        const seconds =
            totalSeconds % 60;


        const time =
            `${String(hours).padStart(2, "0")} : ` +
            `${String(minutes).padStart(2, "0")} : ` +
            `${String(seconds).padStart(2, "0")}`;


        countdowns.forEach(
            countdown => {

                countdown.textContent =
                    time;

            }
        );

    }


    updateCountdown();


    countdownTimer =
        setInterval(
            updateCountdown,
            1000
        );


    console.log(
        "[Countdown] Started."
    );

}


// =========================================================
// UPDATE INVITATION POPUP
// =========================================================

function updateInvitationPopup() {

    const invitation =
        getStoredInvitation();


    if (!invitation) {

        return;

    }


    // =====================================================
    // PHONE
    // =====================================================

    const phoneElements =
        document.querySelectorAll(
            ".invitation-phone"
        );


    if (
        phoneElements.length &&
        invitation.phone
    ) {

        phoneElements.forEach(
            element => {

                element.textContent =
                    invitation.phone;

            }
        );

    }


    // =====================================================
    // UNIQUE TOKEN
    // =====================================================

    const tokenElements =
        document.querySelectorAll(
            ".invitation-token"
        );


    if (
        tokenElements.length &&
        invitation.unique_token
    ) {

        tokenElements.forEach(
            element => {

                element.textContent =
                    invitation.unique_token;

            }
        );

    }


    // =====================================================
    // DATE FORMATTER
    // =====================================================

    function formatInvitationDate(
        dateString
    ) {

        if (!dateString) {

            return "";

        }


        let utcString =
            String(
                dateString
            ).trim();


        if (
            !utcString.includes("T")
        ) {

            utcString =
                utcString.replace(
                    " ",
                    "T"
                ) + "Z";

        }


        const date =
            new Date(
                utcString
            );


        if (
            Number.isNaN(
                date.getTime()
            )
        ) {

            return "";

        }


        const formatted =
            new Intl.DateTimeFormat(
                "en-GB",
                {
                    timeZone:
                        "Europe/Amsterdam",

                    weekday:
                        "long",

                    day:
                        "numeric",

                    month:
                        "long",

                    hour:
                        "2-digit",

                    minute:
                        "2-digit",

                    hour12:
                        false
                }
            ).format(date);


        return formatted
            .replace(
                ", ",
                " at "
            )
            .replace(
                ":",
                "."
            );

    }


    // =====================================================
    // RECEIVED
    // =====================================================

    const receivedElements =
        document.querySelectorAll(
            ".invitation-received"
        );


    receivedElements.forEach(
        element => {

            if (
                invitation.received_invitation
            ) {

                element.textContent =
                    formatInvitationDate(
                        invitation.received_invitation
                    );

            }

        }
    );


    // =====================================================
    // EXPIRES
    // =====================================================

    const expiresElements =
        document.querySelectorAll(
            ".invitation-expires"
        );


    expiresElements.forEach(
        element => {

            if (
                invitation.expires_at
            ) {

                element.textContent =
                    formatInvitationDate(
                        invitation.expires_at
                    );

            }

        }
    );

}



// =========================================================
// RECORD INVITATION OPEN
// =========================================================

function recordInvitationOpen(token) {

    if (!token) {

        console.error(
            "[Invitation] Cannot record open — no token."
        );

        return;

    }


    const cleanToken =
        String(token).trim();


    console.log(
        "[Invitation] Recording invitation open:",
        cleanToken
    );


    fetch(
        `${API_URL}/invitation/opened`,
        {
            method: "POST",

            headers: {
                "Content-Type":
                    "application/json"
            },

            body: JSON.stringify({
                unique_token:
                    cleanToken
            }),

            cache:
                "no-store",

            keepalive:
                true
        }
    )
        .then(async response => {

            const text =
                await response.text();


            let data = {};

            try {

                data =
                    JSON.parse(text);

            } catch {

                console.error(
                    "[Invitation] Open tracking returned invalid JSON:",
                    text
                );

            }


            console.log(
                "[Invitation] Open tracking HTTP:",
                response.status
            );


            console.log(
                "[Invitation] Open tracking response:",
                data
            );


            if (!response.ok) {

                throw new Error(
                    `Open tracking failed: ${response.status} ${data.error || text}`
                );

            }


            return data;

        })
        .then(data => {

            console.log(
                "[Invitation] ✓ Open recorded:",
                data
            );

        })
        .catch(error => {

            console.error(
                "[Invitation] Could not record open:",
                error
            );

        });

}


// =========================================================
// VALIDATE INVITATION
// =========================================================

function validateInvitation(
    phone,
    token
) {

    const validationURL =
        `${API_URL}/invitation?phone=${encodeURIComponent(phone)}&token=${encodeURIComponent(token)}`;


    console.log(
        "[Invitation] Validating invitation..."
    );


    return fetch(
        validationURL,
        {
            cache: "no-store"
        }
    )
        .then(response => {

            return response
                .json()
                .catch(() => ({
                    valid: false
                }));

        })
        .then(data => {

            console.log(
                "[Invitation] Validation:",
                data
            );


            if (
                !data.valid &&
                data.error ===
                    "Invitation expired"
            ) {

                saveInvitationState(
                    "expired"
                );


                applyInvitationState([
                    "inactive",
                    "expired"
                ]);


                return;

            }


            if (!data.valid) {

                saveInvitationState(
                    "inactive"
                );


                applyInvitationState([
                    "inactive"
                ]);


                return;

            }


            console.log(
    "[Invitation] ✓ Invitation valid"
);


// =====================================================
// RECORD OPEN IMMEDIATELY
// =====================================================

recordInvitationOpen(
    token
);


return createSession(
    phone,
    token
);

        });

}


// =========================================================
// CREATE SESSION
// =========================================================

function createSession(
    phone,
    token
) {

    const sessionURL =
        `${API_URL}/invitation/session?phone=${encodeURIComponent(phone)}&token=${encodeURIComponent(token)}`;


    console.log(
        "[Invitation] Creating invitation session..."
    );


    return fetch(
        sessionURL,
        {
            credentials:
                "include",

            cache:
                "no-store"
        }
    )
        .then(response => {

            if (!response.ok) {

                throw new Error(
                    `Session request failed: ${response.status}`
                );

            }


            return response.json();

        })
        .then(data => {

            console.log(
                "[Invitation] Session:",
                data
            );


            if (!data.valid) {

                saveInvitationState(
                    "inactive"
                );


                applyInvitationState([
                    "inactive"
                ]);


                return;

            }


            saveInvitationState(
                "active",
                data.expires_at
            );


            localStorage.setItem(
                DATA_KEY,
                JSON.stringify({

                    phone:
                        data.phone,

                    unique_token:
                        data.unique_token ||
                        token,

                    received_invitation:
                        data.received_invitation,

                    expires_at:
                        data.expires_at

                })
            );


            applyInvitationState([
                "active"
            ]);


            updateInvitationPopup();

            startCountdown();


            


            console.log(
                "[Invitation] ✓ Invitation active"
            );

        });

}


// =========================================================
// CONTINUE WITH INVITATION CODE
// =========================================================

async function continueWithInvitationCode() {

    const input =
        document.querySelector(
            ".invitation-code"
        );


    if (!input) {

        console.error(
            "[Invitation] Invitation code input not found."
        );

        return;

    }


    const code =
        String(
            input.value || ""
        )
            .trim();


    // =====================================================
    // VALIDATE CODE FORMAT
    // =====================================================

    if (
        !/^\d{6}$/.test(code)
    ) {

        showInvitationCodeError(
            "Please enter your 6-digit invitation code."
        );

        return;

    }


    console.log(
        "[Invitation] Continuing with invitation code:",
        code
    );


    const buttons =
        document.querySelectorAll(
            "[data-invitation-continue]"
        );


    buttons.forEach(
        button => {

            button.disabled =
                true;

        }
    );


    clearInvitationCodeError();


    try {

        const response =
            await fetch(
                `${API_URL}/invitation/continue`,
                {
                    method:
                        "POST",

                    headers: {
                        "Content-Type":
                            "application/json"
                    },

                    body:
                        JSON.stringify({
                            unique_token:
                                code
                        }),

                    credentials:
                        "include",

                    cache:
                        "no-store"
                }
            );


        const data =
            await response
                .json()
                .catch(() => ({}));


        console.log(
            "[Invitation] Continue response:",
            response.status,
            data
        );


        if (
            !response.ok ||
            !data.valid
        ) {

            showInvitationCodeError(
                data.error ||
                "Invalid invitation code."
            );


            buttons.forEach(
                button => {

                    button.disabled =
                        false;

                }
            );


            return;

        }


        // =================================================
        // SAVE ACTIVE INVITATION
        // =================================================

        saveInvitationState(
            "active",
            data.expires_at
        );


        localStorage.setItem(
            DATA_KEY,
            JSON.stringify({

                phone:
                    data.phone,

                unique_token:
                    data.unique_token ||
                    code,

                received_invitation:
                    data.received_invitation,

                expires_at:
                    data.expires_at

            })
        );


        applyInvitationState([
            "active"
        ]);


        updateInvitationPopup();

        startCountdown();


        // =================================================
        // RECORD OPEN
        // =================================================

        recordInvitationOpen(
            data.unique_token ||
            code
        );


        console.log(
            "[Invitation] ✓ Continue code accepted."
        );


    } catch (error) {

        console.error(
            "[Invitation] Continue code error:",
            error
        );


        showInvitationCodeError(
            "Something went wrong. Please try again."
        );


        buttons.forEach(
            button => {

                button.disabled =
                    false;

            }
        );

    }

}


// =========================================================
// INVITATION CODE ERROR
// =========================================================

function showInvitationCodeError(
    message
) {

    const errorElements =
        document.querySelectorAll(
            ".invitation-code-error"
        );


    errorElements.forEach(
        element => {

            element.textContent =
                message;

            element.removeAttribute(
                "hidden"
            );

        }
    );

}


function clearInvitationCodeError() {

    const errorElements =
        document.querySelectorAll(
            ".invitation-code-error"
        );


    errorElements.forEach(
        element => {

            element.textContent =
                "";

            element.setAttribute(
                "hidden",
                ""
            );

        }
    );

}


// =========================================================
// INITIALISE CONTINUE CODE
// =========================================================

let continueListenerAttached =
    false;


function initialiseContinueCode() {

    if (
        continueListenerAttached
    ) {

        return;

    }


    continueListenerAttached =
        true;


    document.addEventListener(
        "click",
        function (event) {

            const button =
                event.target.closest(
                    "[data-invitation-continue]"
                );


            if (!button) {

                return;

            }


            event.preventDefault();

            event.stopPropagation();


            continueWithInvitationCode();

        },
        true
    );


    document.addEventListener(
        "keydown",
        function (event) {

            if (
                event.key !==
                "Enter"
            ) {

                return;

            }


            const input =
                event.target.closest(
                    ".invitation-code"
                );


            if (!input) {

                return;

            }


            event.preventDefault();


            continueWithInvitationCode();

        },
        true
    );


    console.log(
        "[Invitation] Continue-code listener attached."
    );

}


// =========================================================
// RECORD CHECKOUT
// =========================================================

async function recordCheckout(
    token
) {

    if (!token) {

        console.error(
            "[Invitation] Cannot record checkout — no token."
        );

        return false;

    }


    console.log(
        "[Invitation] Sending checkout tracking:",
        token
    );


    try {

        const response =
            await fetch(
                `${API_URL}/invitation/checkout`,
                {
                    method:
                        "POST",

                    headers: {
                        "Content-Type":
                            "application/json"
                    },

                    body:
                        JSON.stringify({
                            unique_token:
                                String(
                                    token
                                ).trim()
                        }),

                    keepalive:
                        true
                }
            );


        console.log(
            "[Invitation] Checkout tracking HTTP:",
            response.status
        );


        const responseText =
            await response.text();


        console.log(
            "[Invitation] Checkout tracking response:",
            responseText
        );


        if (!response.ok) {

            throw new Error(
                `Checkout tracking failed: ${response.status} ${responseText}`
            );

        }


        console.log(
            "[Invitation] ✓ Checkout recorded successfully"
        );


        return true;

    } catch (error) {

        console.error(
            "[Invitation] Checkout tracking failed:",
            error
        );


        return false;

    }

}


// =========================================================
// CHECKOUT BUTTON
// =========================================================

function initialiseCheckoutButtons() {

    if (
        checkoutClickListenerAttached
    ) {

        return;

    }


    checkoutClickListenerAttached =
        true;


    console.log(
        "[Checkout] Global checkout listener attached."
    );


    document.addEventListener(
        "click",
        async function (event) {

            const button =
                event.target.closest(
                    "[data-checkout-variant]"
                );


            if (!button) {

                return;

            }


            event.preventDefault();

            event.stopPropagation();

            event.stopImmediatePropagation();


            if (
                button.dataset.checkoutLoading ===
                "true"
            ) {

                return;

            }


            button.dataset.checkoutLoading =
                "true";


            const variantId =
                button.getAttribute(
                    "data-checkout-variant"
                );


            const invitation =
                getStoredInvitation();


            const token =
                invitation?.unique_token;


            if (!token) {

                console.error(
                    "[Checkout] NO TOKEN."
                );

                button.dataset.checkoutLoading =
                    "false";

                return;

            }


            await recordCheckout(
                token
            );


            try {

                const clearResponse =
                    await fetch(
                        "/cart/clear.js",
                        {
                            method:
                                "POST",

                            headers: {
                                Accept:
                                    "application/json"
                            }
                        }
                    );


                if (!clearResponse.ok) {

                    throw new Error(
                        "Could not clear cart."
                    );

                }


                const addResponse =
                    await fetch(
                        "/cart/add.js",
                        {
                            method:
                                "POST",

                            headers: {
                                "Content-Type":
                                    "application/json",

                                Accept:
                                    "application/json"
                            },

                            body:
                                JSON.stringify({

                                    items: [

                                        {
                                            id:
                                                Number(
                                                    variantId
                                                ),

                                            quantity:
                                                1

                                        }

                                    ]

                                })

                        }
                    );


                if (!addResponse.ok) {

                    const errorText =
                        await addResponse.text();


                    throw new Error(
                        "Could not add product: " +
                        addResponse.status +
                        " " +
                        errorText
                    );

                }


                window.location.href =
                    "/checkout";


            } catch (error) {

                console.error(
                    "[Checkout] Checkout error:",
                    error
                );


                button.dataset.checkoutLoading =
                    "false";

            }

        },
        true
    );

}


// =========================================================
// CLEAN URL
// =========================================================

function cleanURL() {

    const url =
        new URL(
            window.location.href
        );


    url.searchParams.delete(
        "phone"
    );


    url.searchParams.delete(
        "token"
    );


    window.history.replaceState(
        {},
        document.title,
        url.toString()
    );


    console.log(
        "[Invitation] URL cleaned"
    );

}


// =========================================================
// APPLY LOCAL STATE
// =========================================================

function applyLocalState() {

    const localState =
        getLocalInvitationState();


    console.log(
        "[Invitation] Local state:",
        localState
    );


    if (
        localState === "active"
    ) {

        applyInvitationState([
            "active"
        ]);


        updateInvitationPopup();

        startCountdown();

        return;

    }


    if (
        localState === "expired"
    ) {

        applyInvitationState([
            "inactive",
            "expired"
        ]);


        return;

    }


    applyInvitationState([
        "inactive"
    ]);

}


// =========================================================
// INITIALISE
// =========================================================

function initInvitation() {

    console.log(
        "[Invitation] Initialising..."
    );


    startInvitationObserver();

    initialiseInvitationButtons();

    initialiseContinueCode();

    initialiseCheckoutButtons();


    const params =
        new URLSearchParams(
            window.location.search
        );


    const phone =
        params.get("phone");


    const token =
        params.get("token");


    // =====================================================
    // INVITATION URL
    // =====================================================

    if (
        phone &&
        token
    ) {

        console.log(
            "[Invitation] Invitation URL detected"
        );


        validateInvitation(
            phone,
            token
        )
            .then(() => {

                cleanURL();

            })
            .catch(error => {

                console.error(
                    "[Invitation] Error:",
                    error
                );


                saveInvitationState(
                    "inactive"
                );


                applyInvitationState([
                    "inactive"
                ]);

            });


        return;

    }


    // =====================================================
    // NO INVITATION URL
    // =====================================================

    applyLocalState();

}


// =========================================================
// START
// =========================================================

console.log(
    "[Invitation] Script loaded"
);


if (
    document.readyState ===
    "loading"
) {

    document.addEventListener(
        "DOMContentLoaded",
        initInvitation,
        {
            once: true
        }
    );

} else {

    initInvitation();

}


})();
